import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Box, useMediaQuery, useTheme, Typography } from "@mui/material";
import { fontFamilyAll } from "../assets/commonComponents/COLORS";

const Banner = ({ bannerImages,bannerData}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box sx={{ position: "relative", height: isMobile ? "50vh" : "100vh" }}>
            <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={0}
                slidesPerView={1}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop
                speed={1200}
                style={{ height: "100%" }}
            >
                {bannerImages.map((image, index) => (
                    <SwiperSlide key={index}>
                        <Box
                            component="img"
                            src={image}
                            alt={`Banner ${index + 1}`}
                            loading="lazy"
                            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Overlay Text */}
            <Box
                sx={{
                    position: "absolute",
                    top: isMobile?"60%":"50%",
                    left: "5%",
                    transform: "translateY(-50%)",
                    color: "white",
                    zIndex: 10,
                    maxWidth: "40%",
                    padding: "20px",
                    borderRadius: "10px",
                }}
            >
                <Typography variant={isMobile ? "h5" : "h6"} fontWeight={700} textAlign={"left"} sx={{fontFamily:`${fontFamilyAll} !important`}} >
                    {bannerData[0]}
                </Typography>
                <Typography variant={isMobile ? "body1" : "h3"} textAlign={"left"} fontFamily={fontFamilyAll} >
                    {bannerData[1]}
                </Typography>
                <Typography variant={isMobile ? "body1" : "h5"} textAlign={"left"} mt={3} fontFamily={fontFamilyAll}>
                    {bannerData[2]}
                </Typography>
            </Box>
        </Box>
    );
};

export default Banner;